import React from 'react';
import { FormControl, InputLabel, MenuItem, MuiSelect } from './index.view';

export type Item = {
  value: string | number | undefined;
  label: string;
  isActive?: boolean;
};

type SelectProps = {
  id: string;
  value: string | number;
  label: string;
  dropdownList?: Item[] | string[];
  disabled?: boolean;
  name: string;
  nullable: boolean;
  style?: Record<string, unknown>;
  onChange?: (event: any) => void;
};
const Select: React.VFC<SelectProps> = ({
  id,
  label,
  disabled,
  dropdownList = [],
  value = '',
  name,
  onChange,
  style,
  nullable,
  ...rest
}) => {
  return (
    <FormControl disabled={disabled} fullWidth>
      <InputLabel
        id={`${id}-label`}
        shrink={disabled || (value !== null && value !== undefined && value !== '')}
      >
        {label}
      </InputLabel>
      <MuiSelect
        labelId={`${id}-label`}
        id={`${id ?? name}`}
        label={label}
        value={value}
        style={style}
        name={name}
        onChange={onChange}
        {...rest}
      >
        {dropdownList?.map((item: Item | string, i: number) => {
          let value = typeof item === 'string' ? item : item?.value;
          if (item === '-') {
            value = undefined;
          }
          const label = typeof item === 'string' ? item : item?.label;
          const isActive =
            typeof item === 'string' ? item : item?.isActive === undefined ? true : item.isActive;

          return (
            <MenuItem key={i} value={value} data-testid={i} disabled={!isActive}>
              {label}
            </MenuItem>
          );
        })}
      </MuiSelect>
    </FormControl>
  );
};

export default Select;
